module.exports = __webpack_public_path__ + "static/map-argentina-485e1baea39b41d73a4ef5550c65e70b.png";